export var StorageLocalEnum;
(function (StorageLocalEnum) {
    StorageLocalEnum["COUNTRY"] = "country";
    StorageLocalEnum["EXPIRES_IN"] = "expiresIn";
    StorageLocalEnum["LOCALE"] = "locale";
    StorageLocalEnum["REMEMBER_USER"] = "rememberUser";
    StorageLocalEnum["LANGUAGE"] = "language";
    StorageLocalEnum["SESSION_EXPIRES_AT"] = "sessionExpiresAt";
    StorageLocalEnum["TRANSLATIONS"] = "translations";
    StorageLocalEnum["VERSION"] = "version";
    StorageLocalEnum["USER_ALIAS"] = "userAlias";
    StorageLocalEnum["USERNAME"] = "username";
    StorageLocalEnum["IS_USER_LOGGED"] = "isUserLogged";
})(StorageLocalEnum || (StorageLocalEnum = {}));
//# sourceMappingURL=storage-local.enum.js.map